<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-course-information`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 4h32a2 2 0 011.995 1.85L42 6v37a2 2 0 01-1.85 1.995L40 45H8a2 2 0 01-1.995-1.85L6 43V6a2 2 0 011.85-1.995L8 4h32H8zm30 4H27v12.929a2 2 0 01-2.809 1.829L20 20.905l-4.191 1.853A2 2 0 0113 20.928V8h-3v33h28V8zm-4 25a1 1 0 011 1v1.5a1 1 0 01-1 1h-7a1 1 0 01-1-1V34a1 1 0 011-1h7zM23 8h-6v9.858l3-1.327 3 1.327V8z"/></svg>
</template>
<script>

export default {
  name: 'IconCourseInformation',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
